module.exports = __webpack_public_path__ + "img/pet-passport_B09T65PF4J.62b6bdba.jpg";